import script from "./selectColor.vue?vue&type=script&setup=true&lang=js"
export * from "./selectColor.vue?vue&type=script&setup=true&lang=js"

import "./selectColor.vue?vue&type=style&index=0&id=3573a5e6&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3573a5e6"]])

export default __exports__